import React, { useEffect, useState } from "react";
import DataComponent from "../../../components/DataComponent";
import Icon from "../../../components/Icon";
import companyIcon from "../../../assets/images/icon/company.svg";
import keyIcon from "../../../assets/images/icon/key.svg";
import { CardUnit } from "../../../components/ContentLayout";
import { CardBody, CardHeader, CardTitle } from "reactstrap";
import {
  getFinancesAccounts,
  getFinancesType,
  modifyFinancesAccounts,
  postFinancesAuth,
} from "../../../apis/finances/auth";
import { isEmpty } from "lodash";
import { viewLoading } from "../../../utils/loading";
import Button from "../../../components/Button";

export default ({ permission }) => {
  const [accountInfo, setAccountInfo] = useState({});
  const [originInfo, setOriginInfo] = useState({});
  const [certInfo, setCertInfo] = useState({
    userId: "",
    userPw: "",
  });
  // 비밀번호 하이드
  const [isHidePassword, setIsHidePassword] = useState(true);

  useEffect(() => {
    getAccount();
  }, []);

  const handleOnLogin = () => {
    const { userId, userPw } = certInfo;
    if (!userId || !userPw) {
      return;
    }
    viewLoading(true);
    if (isEmpty(accountInfo) && isEmpty(originInfo)) {
      // 첫 등록
      getFinancesType("cardsales").then((res) => {
        const formData = {
          orgCd: "cardsales",
          loginMethod: "ID",
          userId,
          userPw,
        };

        postFinancesAuth(formData)
          .then(() => {
            getAccount();
          })
          .catch(() => { })
          .finally(() => {
            viewLoading(false);
          });
      });
    }

    if (isEmpty(accountInfo) && !isEmpty(originInfo)) {
      // 변경
      const formData = {
        loginMethod: "ID",
        userId,
        userPw,
      };
      modifyFinancesAccounts(originInfo.idx, formData).then(() => {
        getAccount()
      }).catch(() => { }).finally(() => viewLoading(false))

    }
  };

  const getAccount = () => {
    getFinancesAccounts("cardsales")
      .then((res) => {
        res = res.data.accounts.find(
          (account) => account.orgCd === "cardsales"
        );
        setAccountInfo({ ...res });
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleOnAccountChange = () => {
    setOriginInfo(accountInfo)
    setAccountInfo({})
    setCertInfo({ userId: "", userPw: "" });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setCertInfo({
      ...certInfo,
      [name]: value,
    });
  };

  return (
    <div className="crefia-wrap">
      <CardHeader className="border-bottom-none">
        <CardTitle>신용카드 매출</CardTitle>
        <CardUnit>
          {permission.level > 1 && isEmpty(accountInfo) && !isEmpty(originInfo) && (
            <Button
              label="취소"
              size="sm"
              color="text"
              onClick={() => {
                setAccountInfo(originInfo)
                setOriginInfo({})
              }}
            />
          )}
          {permission.level > 1 && (
            <DataComponent
              field={{
                type: "button",
                label: !isEmpty(accountInfo) ? "아이디 변경" : "저장하기",
                size: "small",
                color: "line",
                action: !isEmpty(accountInfo) ? handleOnAccountChange : handleOnLogin,
              }}
            />
          )}
        </CardUnit>
      </CardHeader>
      <CardBody className="p-0 margin-top-14">
        <div className="cert-on-box">
          <div className="left-site">
            <div className="company-key-icon-wrap">
              <Icon src={companyIcon} />
              <Icon src={keyIcon} className="key-icon" />
            </div>
          </div>
          <form className="right-site" onSubmit={handleOnLogin}>
            {!isEmpty(accountInfo) ? (
              <div className="text-wrap">
                <p className="text-title">{accountInfo.userId}</p>
                <p className="text-discription">사용 중인 아이디</p>
              </div>
            ) : (
              <div className="input-wrap">
                <input
                  className="id-input"
                  placeholder="여신금융협회 아이디"
                  name="userId"
                  onChange={handleOnChange}
                />
                <div className="horizontal-divider" />
                <div className="password-wrap">
                  <input
                    className="password-input"
                    type={isHidePassword ? "password" : "text"}
                    placeholder="여신금융협회 비밀번호"
                    name="userPw"
                    onChange={handleOnChange}
                  />
                  <span className="icon">
                    <i
                      className={`mdi ${isHidePassword ? "mdi-eye" : "mdi-eye-off"
                        } font-size-24`}
                      onClick={() => setIsHidePassword(!isHidePassword)}
                    />
                  </span>
                </div>
              </div>
            )}
          </form>
        </div>
      </CardBody>
    </div>
  );
};
